/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import AtlaskitLozenge from '@atlaskit/lozenge';
import { useFlexibleUiOptionContext } from '../../../../../state/flexible-ui-context';
import LozengeAction from './lozenge-action';
var styles = css({
  display: 'inline-flex',
  lineHeight: 'inherit'
});

/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */
var Lozenge = function Lozenge(_ref) {
  var action = _ref.action,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    name = _ref.name,
    overrideCss = _ref.overrideCss,
    style = _ref.style,
    text = _ref.text,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-lozenge' : _ref$testId;
  var ui = useFlexibleUiOptionContext();
  if (!text) {
    return null;
  }
  var lozenge = action ? jsx(LozengeAction, {
    action: action,
    appearance: appearance,
    testId: testId,
    text: text,
    zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex
  }) : jsx(AtlaskitLozenge, {
    appearance: appearance
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    testId: "".concat(testId, "-lozenge")
  }, text);
  return jsx("span", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    css: [styles, overrideCss],
    "data-fit-to-content": true,
    "data-smart-element": name,
    "data-smart-element-lozenge": true,
    "data-testid": testId
  }, lozenge);
};
export default Lozenge;